const handleReadMore = () => {
    const maxItem = 5;
    const contentEl = document.getElementById("jsContentReadMore");
    if (!contentEl) return;

    const itemEls = contentEl.querySelectorAll("dt");
    const btnEl = contentEl.nextElementSibling;
    if (!itemEls.length || !btnEl) return;

    const isMobile = () => window.innerWidth < 768;

    const toggleItems = (expand) => {
        itemEls.forEach((el, i) =>
            el.classList.toggle("show", expand || i < maxItem),
        );
    };

    const updateDisplay = () => {
        if (isMobile()) {
            const isExpand = btnEl.classList.contains("expand");
            toggleItems(isExpand);
            btnEl.style.display = "";
        } else {
            itemEls.forEach((el) => el.classList.add("show"));
            btnEl.style.display = "none";
        }
    };

    updateDisplay();

    btnEl.addEventListener("click", () => {
        const isExpand = btnEl.classList.toggle("expand");
        btnEl.textContent = isExpand ? "閉じる" : "もっとみる";
        toggleItems(isExpand);
    });

    window.addEventListener("resize", updateDisplay);
};

const handleProgramMore = () => {
    const contentEls = document.querySelectorAll(".js-program-more");
    if (!contentEls.length) return;

    const isMobile = () => window.innerWidth < 768;
    const getButtonLabel = (isOpen) =>
        `${isOpen ? "閉じる" : "もっとみる"} <span class="plus" aria-hidden="true"></span>`;

    const instances = Array.from(contentEls)
        .map((content) => {
            const btn = content.querySelector(".js-more");
            if (!btn) return null;

            let isAnimating = false;
            let targetOpenState = null;

            const setButtonState = (isOpen) => {
                btn.classList.toggle("is-open", isOpen);
                btn.innerHTML = getButtonLabel(isOpen);
            };

            const getHeightForState = (isOpen) => {
                const currentState = content.classList.contains("is-open");
                content.classList.toggle("is-open", isOpen);
                const height = content.scrollHeight;
                content.classList.toggle("is-open", currentState);

                return height;
            };

            const animateToState = (isOpen) => {
                const currentState = content.classList.contains("is-open");
                if (isAnimating || currentState === isOpen) return;

                isAnimating = true;
                targetOpenState = isOpen;

                const startHeight = content.getBoundingClientRect().height;
                const endHeight = getHeightForState(isOpen);
                content.style.maxHeight = `${startHeight}px`;
                // Force reflow so transition starts from the current rendered height.
                void content.offsetHeight;

                if (isOpen) {
                    content.classList.add("is-open");
                    setButtonState(true);
                } else {
                    // Keep expanded styles during collapse so content is clipped smoothly.
                    setButtonState(false);
                }

                requestAnimationFrame(() => {
                    content.style.maxHeight = `${endHeight}px`;
                });
            };

            const handleTransitionEnd = (event) => {
                if (
                    event.target !== content ||
                    event.propertyName !== "max-height"
                ) {
                    return;
                }
                if (!isAnimating || targetOpenState === null) return;

                if (!targetOpenState) {
                    content.classList.remove("is-open");
                }

                isAnimating = false;
                targetOpenState = null;
                content.style.maxHeight = `${content.scrollHeight}px`;
            };

            const update = () => {
                if (!isMobile()) {
                    content.classList.add("is-open");
                    setButtonState(true);
                    content.style.maxHeight = "none";
                    return;
                }

                isAnimating = false;
                targetOpenState = null;
                content.classList.remove("is-open");
                setButtonState(false);
                content.style.maxHeight = "";
                content.style.maxHeight = `${content.scrollHeight}px`;
            };

            btn.addEventListener("click", () => {
                if (isAnimating || !isMobile()) return;

                animateToState(!content.classList.contains("is-open"));
            });

            content.addEventListener("transitionend", handleTransitionEnd);
            update();

            return { update };
        })
        .filter(Boolean);

    if (!instances.length) return;

    window.addEventListener("resize", () => {
        instances.forEach((instance) => instance.update());
    });
};

export { handleReadMore, handleProgramMore };
